import { useState } from "react";
import { CONTENT_HEADING } from "../../constants";
import OpenAccessModal from "../Modal/OpenAccessModal";
import Content from "../global/Content";
import { Link } from "react-router-dom";

const GeneralInfo = () => {
  const [show, setShow] = useState(false);
  return (
    <>
      <Content title={CONTENT_HEADING.GENERAL_INFO}>
        <p className="pera-text tagp">
          Thank you for considering Aakashganga Open for your research.
        </p>
        <p className="pera-text tagp mb-4">
          Before submitting, please ensure that your manuscript is original, complete, ethically compliant and prepared according to the requirements below. Submissions that do not meet the essential requirements may be returned for correction before editorial assessment. This guideline is for submitting to Mega Journals. For specific instructions when submitting to Society Journals please refer to the journal home page.
        </p>
        <div style={{ marginBottom: "2rem", textAlign: "left" }}>
          <button 
            style={{ padding: "8px 16px", fontSize: "18px", backgroundColor: "#BC1C2B", color: "#fff", border: "none", borderRadius: "15px", cursor: "pointer" }}
            onClick={() => window.open("/mega-journal-formatting-guideline", "_blank")}
          >
            FORMATTING GUIDELINES
          </button>
        </div>
      </Content>
      <OpenAccessModal show={show} setShow={setShow} />
    </>
  );
};

export default GeneralInfo;
